var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0462646 6.40957H6.45584V0H0.0462646V6.40957ZM1.21814 1.17188H5.28396V5.23769H1.21814V1.17188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.64 13.5898V19.9973H20.0475V13.5898H13.64ZM18.8756 18.8255H14.8119V14.7617H18.8756V18.8255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.25103 13.5898C1.48392 13.5898 0.0462646 15.0275 0.0462646 16.7946C0.0462646 18.5618 1.48392 19.9994 3.25103 19.9994C5.01814 19.9994 6.45584 18.5618 6.45584 16.7946C6.45584 15.0275 5.01814 13.5898 3.25103 13.5898ZM3.25103 18.8275C2.13009 18.8275 1.21814 17.9156 1.21814 16.7946C1.21814 15.6737 2.13009 14.7617 3.25103 14.7617C4.37197 14.7617 5.28396 15.6737 5.28396 16.7946C5.28396 17.9156 4.37197 18.8275 3.25103 18.8275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6186 6.35254L16.6801 5.97019L18.7416 6.35254L19.015 4.27375L20.0157 2.43125L18.1232 1.52883L16.6801 0.0078125L15.2371 1.52887L13.3445 2.43129L14.3452 4.27379L14.6186 6.35254ZM15.9376 2.49309L16.6801 1.71047L17.4226 2.49309L18.3964 2.95742L17.8816 3.90551L17.7408 4.97512L16.6801 4.7784L15.6194 4.97512L15.4787 3.90551L14.9638 2.95742L15.9376 2.49309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.83687 12.3677V9.87602L4.45059 10.4897L5.27922 9.66109L3.25094 7.63281L1.22266 9.66109L2.05129 10.4897L2.665 9.87602V12.3677H3.83687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.5373 15.7486L9.7087 14.9199L7.68042 16.9482L9.7087 18.9765L10.5373 18.1479L9.92362 17.5341H12.4153V16.3623H9.92362L10.5373 15.7486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.41068 2.00441L10.0244 2.61812H7.53271V3.79H10.0244L9.41068 4.40371L10.2393 5.2323L12.2676 3.20406L10.2393 1.17578L9.41068 2.00441Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.d090e15d57a2c0034ea38e83a8dcdd9a.svg";
export { ForwardRef as ReactComponent };